import { updateItems, indexItems, contactItem, aboutItem } from '@/mocks/home';

export function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          最新更新
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          桔子视频每日内容更新与功能优化动态
        </p>
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-6">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 pl-12">
                <div className="absolute left-[15px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按类型快速浏览桔子视频全部内容资源
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.letter}
              className="flex items-start gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <span className="font-heading text-lg font-bold">{item.letter}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-[10px] text-foreground-400 bg-background-200/70 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          {contactItem.title}
        </h2>
        <p className="text-sm text-foreground-500 mb-8">{contactItem.subtitle}</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
              <i className="ri-mail-line text-lg"></i>
            </div>
            <p className="text-xs text-foreground-400 mb-1">电子邮箱</p>
            <p className="text-sm font-medium text-foreground-900">{contactItem.email}</p>
          </div>
          <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
              <i className="ri-wechat-line text-lg"></i>
            </div>
            <p className="text-xs text-foreground-400 mb-1">微信</p>
            <p className="text-sm font-medium text-foreground-900">{contactItem.wechat}</p>
          </div>
          <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mx-auto mb-3">
              <i className="ri-qq-line text-lg"></i>
            </div>
            <p className="text-xs text-foreground-400 mb-1">QQ</p>
            <p className="text-sm font-medium text-foreground-900">{contactItem.qq}</p>
          </div>
        </div>
        <p className="text-xs text-foreground-400 flex items-center justify-center gap-1">
          <i className="ri-time-line"></i>
          {contactItem.tip}
        </p>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
          {aboutItem.title}
        </h2>
        <div className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-left">
            {aboutItem.content}
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-8 text-center">
            <div>
              <p className="text-2xl font-bold text-primary-500 font-heading">10万+</p>
              <p className="text-xs text-foreground-400">高清片源</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-accent-500 font-heading">200+</p>
              <p className="text-xs text-foreground-400">每日更新</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-primary-500 font-heading">99.9%</p>
              <p className="text-xs text-foreground-400">流畅播放率</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}